import Config from 'conf';

export default socketMiddleware => {
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);

    return {
        sendPushNotification: function(form) {
            return new Promise((resolve, reject) => {
                const sendPushNotification = args => {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    socketMiddleware.off('sendPushNotificationFeedback', sendPushNotification);
                    if (!args.success) reject(new Error());
                    return resolve(args);
                };
                socketOn('sendPushNotificationFeedback', sendPushNotification);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('sendPushNotificationFeedback', sendPushNotification);
                    reject(new Error('timeout'));
                }, Config.timeout_long_socket_order);
                socketEmit('sendPushNotification', form);
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/PushNotification/index.js